import ActiveFilters from 'components/ActiveFilters';
import { useBooking, useSearchParams } from 'hooks';
import { KoobInputStars } from '@koob/ui';

const HotelsActiveFilters = ({ mode, style, children }) => {
  const { setFilters, filters } = useBooking();
  const [searchParams, setSearchParams] = useSearchParams();
  const { stars, kindsIds, searchLocation, kindStyles, sustainableLevel } =
    mode === 'state' ? filters : searchParams;

  const handleClearFilter = (param) => {
    setSearchParams({
      ...searchParams,
      [param]: null,
    });
  };

  return (
    <ActiveFilters style={style}>
      {Boolean(stars) && (
        <ActiveFilters.Filter
          onClear={() => {
            if (mode === 'state') {
              setFilters((current) => ({
                ...current,
                stars: undefined,
              }));
            } else {
              handleClearFilter('stars');
            }
          }}
        >
          {/* A minimum filter, not a rating: filled stars only. */}
          <KoobInputStars value={stars} showEmpty={false} />
        </ActiveFilters.Filter>
      )}

      {(kindsIds || []).map(({ value, label }, index) => (
        <ActiveFilters.Filter
          key={index}
          onClear={() => {
            if (mode === 'state') {
              setFilters({
                ...filters,
                kindsIds: (kindsIds || []).filter(
                  (option) => option.value !== value,
                ),
              });
            } else {
              setSearchParams({
                ...searchParams,
                kindsIds: (kindsIds || []).filter(
                  (option) => option.value !== value,
                ),
              });
            }
          }}
        >
          <span>{label}</span>
        </ActiveFilters.Filter>
      ))}

      {Boolean(searchLocation) && (
        <ActiveFilters.Filter
          onClear={() => handleClearFilter('searchLocation')}
        >
          <span>{searchLocation?.title}</span>
        </ActiveFilters.Filter>
      )}

      {(kindStyles || []).map(({ value, label }, index) => (
        <ActiveFilters.Filter
          key={index}
          onClear={() => {
            if (mode === 'state') {
              setFilters({
                ...filters,
                kindStyles: (kindStyles || []).filter(
                  (option) => option.value !== value,
                ),
              });
            } else {
              setSearchParams({
                ...searchParams,
                kindStyles: (kindStyles || []).filter(
                  (option) => option.value !== value,
                ),
              });
            }
          }}
        >
          <span>{label}</span>
        </ActiveFilters.Filter>
      ))}

      {Boolean(sustainableLevel) && (
        <ActiveFilters.Filter
          onClear={() => {
            if (mode === 'state') {
              setFilters({
                ...filters,
                sustainableLevel: null,
              });
            } else {
              handleClearFilter('sustainableLevel');
            }
          }}
        >
          <span>{sustainableLevel?.label}</span>
        </ActiveFilters.Filter>
      )}
      {children}
    </ActiveFilters>
  );
};

export default HotelsActiveFilters;
